import QRCode from 'qrcode.react';
import { FC } from 'react';
import styled from 'styled-components';

const ORCodeContainerStyled = styled.div`
  display: flex;
  padding: 2rem;
  justify-content: center;
`;

interface QRProps {
  url: string;
}

const QRCodeGenerator: FC<QRProps> = ({ url }) => {
  
  return (
    <ORCodeContainerStyled>
      <QRCode value={url} size={250} bgColor="#ffffff" fgColor="#000000" level="Q" />
    </ORCodeContainerStyled>
  );
};

export default QRCodeGenerator;
